import { type FC } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from '@/components/layout/Sidebar'
import Header from '@/components/layout/Header'
import MobileSidebar from '@/components/layout/MobileSidebar'
import AccessDeniedOverlay from '@/components/common/AccessDeniedOverlay'

const AppLayout: FC = () => {
    return (
        <div className="flex h-screen bg-background">
            <AccessDeniedOverlay />
            {/* Desktop Sidebar */}
            <div className="hidden lg:block">
                <Sidebar />
            </div>

            {/* Mobile Sidebar */}
            <MobileSidebar />

            {/* Main Content */}
            <div className="flex h-full min-w-0 flex-1 flex-col lg:pl-64">
                <div className="flex h-full min-h-0 flex-col overflow-y-auto">
                    {/* Header */}
                    <Header />

                    {/* Page Content */}
                    <main className="flex-1 p-6">
                        <Outlet />
                    </main>
                </div>
            </div>
        </div>
    )
}

export default AppLayout
